module.exports = __webpack_public_path__ + "static/media/dodi-staff-web-hubton.163de7a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/dodi-staff-web-hubton.png
// module id = 183
// module chunks = 0